export default __webpack_public_path__ + "static/media/arrow2.49cbb50a.svg";